import {
  gx,
  hexToRgb,
  makeTheme,
  pxToEm,
  pxToRem,
  toPx,
  toPxValue
} from 'src/theme/adSales/helpers'
import { fonts } from 'src/theme/adSales/fonts'
import { fontSizes, fontWeights, lineHeights, themeTypeStyles } from 'src/theme/adSales/typography'
import { breakpoints, gelTypeStyles } from 'src/theme/adSales/gel'
import { colors } from 'src/theme/adSales/colors'
import { layout } from 'src/theme/adSales/layout'
import { themeUIElementStyles } from 'src/theme/adSales/styles'
import { buttons } from 'src/theme/adSales/buttons'
import { space } from 'src/theme/adSales/space'
import { sizes } from 'src/theme/adSales/sizes'
import { links } from 'src/theme/adSales/links'
import { borders } from 'src/theme/adSales/borders'
import { zIndices } from 'src/theme/adSales/zIndices'
import { textFields } from 'src/theme/adSales/textFields'
import { pageTabs } from 'src/theme/adSales/pageTabs'

export const text = {
  //gel styles
  ...gelTypeStyles,
  //custom theme gel styles
  ...themeTypeStyles
}

export const adSales = makeTheme({
  breakpoints,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  styles: themeUIElementStyles,
  text,
  colors,
  layout,
  buttons,
  space,
  sizes,
  pageTabs,
  links,
  borders,
  zIndices,
  textFields,
  gx,
  pxToRem,
  pxToEm,
  toPx,
  toPxValue,
  hexToRgb
})
